module.exports = __webpack_public_path__ + "static/media/shopping-basket-remove-icon.b4bc4256.png";